
import $ from 'jquery';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { WindowType } from '../../../../util';
import DropZone from '../../dropzone/DropZone';

declare var window: WindowType;

@Component({
  name: 'ContactUploadModal',
  components: {
    DropZone,
  }
})
export default class ContactUploadModal extends Vue {
  get dropzoneUrl(): string {
    return window.application.baseUrl + 'api/v1/contacts/upload';
  }

  get uid(): string {
    return (this as any)._uid;
  }

  public open(): void {
    $(this.$refs.modal!).modal('show');
  }

  public dismiss(): void {
    $(this.$refs.modal!).modal('hide');
  }
}
